module.exports = __webpack_public_path__ + "static/img/444.c74682fd.png";